import { FileContainer } from "./FileContainer";

export class MediaContainer extends FileContainer {
}
